import { GetMySpacesResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const getMySpaces = makeCloudFunction<void, GetMySpacesResponse>(
  "me",
  "getMySpaces",
);
